import { createContext } from 'react';
import type { IDynamicFormContext } from './types';

export const DynamicFormContext = createContext<IDynamicFormContext<any>>(
  {} as IDynamicFormContext<any>,
);
